import React from 'react';
import PropTypes from 'prop-types';
import MimeTypeIcon from 'documents/components/MimeTypeIcon';
import DataTable from 'base/components/table/DataTable/DataTable';
import Flex from 'base/components/Flex';
import Breadcrumb from 'base/components/Breadcrumb';
import { SmallLabelCell, TagListCell } from 'base/components/table';
import SmallLabel from 'base/components/SmallLabel';
import LargeLabel from 'base/components/LargeLabel';
import Date from 'base/components/Date';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import { CloseIcon } from 'base/components/Icon';
import RowActionButton from 'base/components/table/RowActionButton';
import theme from '../../../theme';

const FormatCell = ({row}) => // eslint-disable-line
  <MimeTypeIcon mimeType={row.format} />;


const DateCell = ({row}) => // eslint-disable-line
  <SmallLabel><Date date={row.createdAt} /></SmallLabel>;


const FilteredTable = withGlobalFilter(DataTable);


class OfflineDocumentsList extends React.Component {
  NameCell = ({original}) => { // eslint-disable-line
    const label = (
      <LargeLabel isPrimary isLink onClick={() => this.props.onView(original)}>
        {original && original.name}
      </LargeLabel>
    );
    if (!original || !original.folder) {
      return label;
    }
    const paths = this.getPaths(original.folder);
    return (
      <Flex flexDirection="column">
        <Breadcrumb paths={paths} />
        {label}
      </Flex>
    );
  };

  getPaths = (folderId) => {
    const { foldersById } = this.props;
    const folder = foldersById[folderId];
    return folder.pathIds.map((id) => ({
      path: foldersById[id].route,
      label: foldersById[id].name,
    }));
  };

  render() {
    const {
      data,
      usersById,
      tagsById,
      spacesById,
      allowRemove,
      onRemove,
      ...other
    } = this.props;
    const columns = [
      {
        Header: 'Type',
        id: 'format',
        accessor: (d) => (d.file ? d.file.mime : 'folder'),
        Cell: FormatCell,
        width: 90,
        showOnMobile: true,
      },
      {
        Header: 'Name',
        id: 'name',
        accessor: (d) => {
          if (!d || !d.folder) {
            return d.name;
          }
          const paths = this.getPaths(d.folder);
          return paths.join('/') + d.name;
        },
        Cell: this.NameCell,
        showOnMobile: true,
      },
      {
        Header: 'Space',
        id: 'space',
        width: 200,
        accessor: (row) => spacesById[row.space] && spacesById[row.space].name,
        Cell: SmallLabelCell('space'),
      },
      {
        Header: 'Date',
        accessor: 'createdAt',
        Cell: DateCell,
        width: 110,
      },
      {
        Header: 'Author',
        id: 'createdBy',
        width: 120,
        accessor: (row) => usersById[row.createdBy] && usersById[row.createdBy].fullName,
        Cell: SmallLabelCell('createdBy'),
      },
      {
        Header: 'Tag',
        id: 'tags',
        width: 120,
        accessor: row => { // eslint-disable-line
          return (row.tags ? row.tags.map((tag) => (tagsById[tag] ? tagsById[tag].name : '')) : []);
        },
        Cell: TagListCell('tags'),
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 120,
        Cell: SmallLabelCell('status'),
      },
    ];

    if (allowRemove) {
      columns.push({
        Header: <CloseIcon color={theme.colors.medium} />,
        Cell: ({original}) => { // eslint-disable-line
          return (
            <RowActionButton
              original={original}
              handleClick={onRemove}
            >
              <CloseIcon color={theme.colors.medium} />
            </RowActionButton>
          );
        },
        sortable: false,
        width: 50,
        showOnMobile: false,
      });
    }

    return (
      <FilteredTable
        data={data}
        columns={columns}
        filterKeys={[
          'name',
          'space',
        ]}
        filterLabel="Filter by name, space..."
        defaultSorted={[
          {
            id: 'space',
            desc: false,
          },
          {
            id: 'name',
            desc: false,
          },
        ]}
        {...other}
      />
    );
  }
}

OfflineDocumentsList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
  tagsById: PropTypes.objectOf(PropTypes.any).isRequired,
  foldersById: PropTypes.objectOf(PropTypes.any).isRequired,
  spacesById: PropTypes.objectOf(PropTypes.any).isRequired,
  onView: PropTypes.func.isRequired,
  allowRemove: PropTypes.bool,
  onRemove: PropTypes.func,
};
OfflineDocumentsList.defaultProps = {
  allowRemove: false,
  onRemove: () => {
  },
};

export default OfflineDocumentsList;
